import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.5 12.5H1.217l2.787 2.787h.002L6.793 12.5H4.5V12a7.498 7.498 0 017.606-7.5h0c3.992.054 7.34 3.402 7.394 7.393h0c.053 4.189-3.32 7.607-7.5 7.607a7.534 7.534 0 01-3.684-.974h-.002a.473.473 0 00-.575.092l-.005.006h0a.498.498 0 00.09.78A8.542 8.542 0 0012 20.5c4.77 0 8.632-3.939 8.5-8.746-.122-4.425-3.83-8.131-8.254-8.254l-8.746 9zm0 0V12m0 .5V12m0 0c0-4.77 3.939-8.632 8.746-8.5L3.5 12z",
      fill: "#2d6ded",
      stroke: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.356 11.511c-1.01-.262-1.334-.533-1.334-.955 0-.485.45-.823 1.2-.823.631 0 .947.24 1.062.623.054.177.2.31.387.31h.133a.421.421 0 00.4-.564c-.186-.524-.622-.96-1.315-1.129v-.306a.666.666 0 10-1.333 0v.293c-.863.187-1.556.747-1.556 1.604 0 1.027.849 1.538 2.089 1.836 1.111.267 1.333.658 1.333 1.071 0 .307-.218.796-1.2.796-.733 0-1.11-.263-1.258-.636-.066-.173-.217-.298-.4-.298h-.124a.424.424 0 00-.396.578c.254.618.845.982 1.512 1.125v.297a.666.666 0 101.333 0v-.289c.867-.164 1.555-.666 1.555-1.577 0-1.263-1.08-1.694-2.088-1.956z",
      fill: "#2d6ded",
      stroke: "#2d6ded",
      strokeWidth: 0.6
    }
  )
), d = a;
export {
  d as default
};
